/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useWizardContext } from '../context/WizardContext';
import SelectionCard from '../SelectionCard';
import { getWizardIcon } from '../icons/wizardIcons';

function ResidencyStep() {
    const { residentAnswer, setIsUsResident } = useWizardContext();

    return (
        <div className="wizard-step-cards">
            <SelectionCard
                id="residency-yes"
                label="Yes, I'm a U.S. citizen/resident"
                illustration={<img src={getWizardIcon('citizen')} alt="" />}
                isSelected={residentAnswer === true}
                onSelect={() => setIsUsResident(true)}
            />
            <SelectionCard
                id="residency-no"
                label="No, I'm not a U.S. citizen/resident"
                illustration={<img src={getWizardIcon('non-citizen')} alt="" />}
                isSelected={residentAnswer === false}
                onSelect={() => setIsUsResident(false)}
            />
        </div>
    );
}

export default ResidencyStep;
